import { ActionIcon, Popover, Tooltip } from "@mantine/core";
import { IconSwitchVertical } from "@tabler/icons-react";
import { useProfileStore, useSessionStore } from "../../stores/UserStore";
import { useCallback, useState } from "react";
import { getProfile, switchToUser, updateSelf } from "../../api/UserAPI";
import { useUIStore } from "../../stores/UIStore";
import SwitchCancel from "./SwitchCancel";
import UserSelectorSwitch from "../../components/UserSelector/UserSelectorSwitch";
import { useLanguage } from "../../stores/LanguageStore";
import { switchAuthChannel } from "../../api/axios";
import { getFields } from "../../api/ContactAPI";
import { getOtherPrms, getStatusCustom, getStatusSystem } from "../../api/PRMAPI";
import { getGlobalReport } from "../../api/ReportingAPI";
import { getEmails, getLinkedinAccounts } from "../../api/EmailAPI";

const AllSwitcher = ({ navbarClosed }) => {
  const lang = useLanguage((s) => s.language);
  const profile = useProfileStore((s) => s.profile);
  const setWindowLoading = useUIStore((s) => s.setWindowLoading);
  const unswitchedProfile = useProfileStore((s) => s.unswitchedProfile);
  const setUnswitchedProfile = useProfileStore((s) => s.setUnswitchedProfile);
  const userSwitch = useSessionStore((state) => state.user_switch);
  const setSwitch = useSessionStore((state) => state.setUserSwitch);

  const [opened, setOpened] = useState(false);

  const handleSwitch = useCallback(
    (newUser) => {
      if (newUser) {
        setOpened(false);
        setWindowLoading(true);
        switchToUser(newUser.id)
          .then((response) => {
            let token = response.data?.token;

            // Get the current timestamp in milliseconds
            const currentTimestamp = Date.now();
            const currentDate = new Date(currentTimestamp);
            // Add delay (minutes)
            currentDate.setMinutes(currentDate.getMinutes() + 50);
            const updatedTimestamp = currentDate.getTime();

            let user_switch = {
              token,
              id: newUser.id,
              name: newUser?.name,
              exp: updatedTimestamp,
            };

            setSwitch(user_switch);

            if (!userSwitch) setUnswitchedProfile(profile);

            updateSelf()
              .then(() => {
                getProfile(null, true).then((r) => {
                  useProfileStore.getState().setProfile(r.data.user_profile);
                });

                getFields();
                getOtherPrms();
                getGlobalReport();
                getStatusSystem();
                getStatusCustom();
                getEmails();
                getLinkedinAccounts();
              })
              .catch((err) => {
                useProfileStore.getState().setProfile({
                  id: newUser.id,
                  first_name: newUser.first_name,
                  last_name: newUser?.last_name,
                  email: newUser?.email,
                  permissions: [
                    {
                      default_value: true,
                      is_editable: false,
                      name: "displaySideMenu",
                      remaining: null,
                      used: null,
                      value: true,
                      value_type: "boolean",
                    },
                    {
                      default_value: true,
                      is_editable: false,
                      name: "accessWorkflows",
                      remaining: null,
                      used: null,
                      value: true,
                      value_type: "boolean",
                    },
                    {
                      default_value: true,
                      is_editable: false,
                      name: "accessContactLists",
                      remaining: null,
                      used: null,
                      value: true,
                      value_type: "boolean",
                    },
                    {
                      default_value: true,
                      is_editable: false,
                      name: "accessModels",
                      remaining: null,
                      used: null,
                      value: true,
                      value_type: "boolean",
                    },
                    {
                      default_value: true,
                      is_editable: false,
                      name: "displayForms",
                      remaining: null,
                      used: null,
                      value: true,
                      value_type: "boolean",
                    },
                    {
                      default_value: true,
                      is_editable: false,
                      name: "displaySideMenu",
                      remaining: null,
                      used: null,
                      value: true,
                      value_type: "boolean",
                    },
                    {
                      default_value: true,
                      is_editable: false,
                      name: "accessPRM",
                      remaining: null,
                      used: null,
                      value: true,
                      value_type: "boolean",
                    },
                    {
                      default_value: true,
                      is_editable: false,
                      name: "accessReporting",
                      remaining: null,
                      used: null,
                      value: true,
                      value_type: "boolean",
                    },
                    {
                      default_value: true,
                      is_editable: false,
                      name: "displayResellers",
                      remaining: null,
                      used: null,
                      value: true,
                      value_type: "boolean",
                    },
                    {
                      default_value: true,
                      is_editable: false,
                      name: "displayPricing",
                      remaining: null,
                      used: null,
                      value: true,
                      value_type: "boolean",
                    },
                  ],
                  organizations: [],
                  teams: [],
                  resellers: [],
                  actions_required: [],
                });
              })
              .finally(() => {
                switchAuthChannel.postMessage({
                  type: "SWITCH_REFRESH_SUCCESS",
                  payload: user_switch,
                });
                setWindowLoading(false);
              });
          })
          .catch(() => setWindowLoading(false));
      }
    },
    [setWindowLoading, setSwitch, userSwitch, setUnswitchedProfile, profile]
  );

  return (
    <>
      <Popover
        trapFocus
        position="bottom"
        offset={-8}
        withArrow
        opened={opened}
        onChange={setOpened}
      >
        <Popover.Target>
          <Tooltip label={lang.header.switch} position="bottom-bottom">
            <ActionIcon
              variant="subtle"
              h={60}
              w={48}
              p={0}
              ml={8}
              justify="flex-start"
              radius={0}
              size="lg"
              color={"primary"}
              onClick={() => setOpened(true)}
            >
              <IconSwitchVertical />
            </ActionIcon>
          </Tooltip>
        </Popover.Target>
        <Popover.Dropdown>
          <UserSelectorSwitch onChange={handleSwitch} />
        </Popover.Dropdown>
      </Popover>
      <SwitchCancel navbarClosed={navbarClosed} />
    </>
  );
};

export default AllSwitcher;
